import React, { useCallback } from "react";
import { NoteBackgroundColorOptions } from "@features/context-menus/components/NoteBackgroundColorOptions";
import { AnyObject } from "@thenounproject/lingo-core";

type ItemType = "note" | "portalNote";

type Item = {
  id: string;
  data?: {
    backgroundColor?: string;
  };
  displayProperties?: {
    cardBackgroundColor?: string;
  };
};

type NoteUpdates = {
  updatedItems: {
    uuid: string;
    data?: {
      background_color: string;
    };
    display_properties?: {
      card_background_color: string;
    };
  }[];
};

type PortalNoteUpdates = {
  portalItemId: string;
  updates: {
    data: {
      background_color: string;
    };
  };
};

type SaveFn = (args: AnyObject) => void;

type ToolbarColorMenuProps = {
  item: Item;
  saveFn: SaveFn;
  type: ItemType;
};

export default function ToolbarColorMenu({ item, saveFn, type }: ToolbarColorMenuProps) {
  const selectedColor = item.displayProperties?.cardBackgroundColor || "#ff0000";

  const editNoteBackground = useCallback(
    (background: string) => {
      let updates: NoteUpdates | PortalNoteUpdates;

      if (type === "portalNote") {
        updates = { portalItemId: item.id, updates: { data: { background_color: background } } };
      } else {
        updates = {
          updatedItems: [
            { uuid: item.id, display_properties: { card_background_color: background } },
          ],
        };
      }

      void saveFn(updates);
    },
    [item.id, saveFn, type]
  );

  return (
    <NoteBackgroundColorOptions
      selectedPreset={selectedColor}
      editItemBackground={editNoteBackground}
      nested={false}
    />
  );
}
